// index.tsx
import React from 'react';
import { Box, Button } from '@mui/material';
import { Rocket } from 'lucide-mui';
import { ToggleSetting, SettingsSection } from '../common';
import Webhooks from './webhooks';
import ApiCredentials from './ApiCredentials';
import ZoomIntegration from './ZoomIntegration';
import { config } from '../../../../config';
import ContactSalesForm from '../../sales/ContactSalesForm';
import ActionDialog from '../../globalModals/ActionDialog';

const Integrations = () => {
  const [salesDialogOpen, setSalesDialogOpen] = React.useState(false);

  let zoomIntegration;
  if (config.enableZoomIntegration) {
    zoomIntegration = (
      <SettingsSection title="Zoom Integration">
        <ZoomIntegration />
      </SettingsSection>
    );
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        overflow: 'auto',
        bgcolor: 'transparent',
        px: 3,
        pt: 1,
        pb: 3,
        '& > *:not(:last-child)': {
          mb: 3,
        },
      }}
    >
      {zoomIntegration}

      <SettingsSection title="Webhooks">
        <Webhooks />
      </SettingsSection>

      <SettingsSection title="API">
        <ApiCredentials />
      </SettingsSection>

      <SettingsSection title="Enterprise Features">
        <ToggleSetting
          checked={false}
          onChange={() => {}}
          label="Advanced Integrations"
          description="Unlock enterprise-grade integration capabilities including custom webhooks, advanced API access, SSO integration, audit logs, and dedicated integration support for your development team."
          icon={<Rocket sx={{ width: 24, height: 24 }} />}
          rightElement={
            <Button
              onClick={() => setSalesDialogOpen(true)}
              variant="contained"
              color="primary"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                py: 1,
                px: 2.5,
              }}
            >
              Contact Sales
            </Button>
          }
        />
      </SettingsSection>

      <ActionDialog
        title="Get in touch"
        open={salesDialogOpen}
        onClose={() => setSalesDialogOpen(false)}
        maxWidth="md"
        fullWidth
        actions={[]}
      >
        <Box>
          <ContactSalesForm formSource="Integrations Settings - Enterprise Enquiry" />
        </Box>
      </ActionDialog>
    </Box>
  );
};

export default Integrations;
